import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentDetails } from '@acorn-portal/shared/src/services/api';

const INITIAL_STATE: DocumentDetails[] = [];

export const policyDocumentsSlice = createSlice({
	name: 'policyDocuments',
	initialState: INITIAL_STATE,
	reducers: {
		clearDocuments: () => ({
			...INITIAL_STATE,
		}),
		setPolicyDocuments: (state, action: PayloadAction<DocumentDetails[]>) => ({
			...state,
			...action.payload,
		}),
	},
});

export const { setPolicyDocuments, clearDocuments } = policyDocumentsSlice.actions;
export default policyDocumentsSlice.reducer;
